// 引入request
import request from "@/utils/request";

//查询课程
export function getQuerycour(id) { 
    return request({
      url: '/web/course/querywebcourse/'+id,
      method: 'get',
    })
}

//查询课程文章和问题
export function getQuestions(data) { 
  return request({
    url: '/web/course/querycoursearticleandquestions',
    method: 'get',
    params:data,
  })
}

//横向捕获查询
export function getCapture(gameId) {
    return request({
      url: '/web/game/lateralCapture/'+ gameId,
      method: 'get',
    })
}


//纵向
export function getRection(gameId) {
    return request({
      url: '/web/game/longitudinalCapture/'+ gameId,
      method: 'get',
    })
}

//对角捕捉
export function getDiagonal(gameId) {
  return request({
    url: '/web/game/diagonalCapture/'+ gameId,
    method: 'get',
  })
}

//8字 
export function getBdezng(gameId) {
  return request({
    url: '/web/game/eightWordCapture/'+ gameId,
    method: 'get',
   
  })
}
//语句快闪 
export function getStatement(gameId) {
  return request({
    url: '/web/game/phraseFastFlash/'+ gameId,
    method: 'get',
   
  })
}

//字母快闪 
export function getLetter(gameId) {
  return request({
    url: '/web/game/alphabetFastFlash/'+ gameId,
    method: 'get',
   
  })
}

//字符快闪 
export function getCharacter(gameId) {
  return request({
    url: '/web/game/characterFlash/'+ gameId,
    method: 'get',
   
  })
}

//数字快闪 
export function getDigital(gameId) {
  return request({
    url: '/web/game/digitalFastFlash/'+ gameId,
    method: 'get',
   
  })
}

//色块快闪 
export function getColour(gameId) {
  return request({
    url: '/web/game/colorBlockSort/'+ gameId,
    method: 'get',
   
  })
}
//图片快闪 
export function getImageFlash(gameId) {
  return request({
    url: '/web/game/pictureFastFlash/'+ gameId,
    method: 'get',
  })
}

//非左即右快闪 
export function  getNotLeftbutRight(gameId) {
  return request({
    url: '/web/game/leftOrRight/'+ gameId,
    method: 'get',
  })
}

//一览无余
export function  getAtGlance(gameId) {
  return request({
    url: '/web/game/atAGlance/'+ gameId,
    method: 'get',
  })
}

//记忆犹新
export function  getRemember(gameId) {
  return request({
    url: '/web/game/rememberVividly/'+ gameId,
    method: 'get',
  })
}

//明辨是非
export function  getDiscerning(gameId) {
  return request({
    url: '/web/game/distinguishRightOrWrong/'+ gameId,
    method: 'get',
  })
}

//数字舒尔特
export function  getSchulteGrid(gameId) {
  return request({
    url: '/web/game/schulteGrid/'+ gameId,
    method: 'get',
  })
}

//慧眼识珠
export function  getEyesIdentify(gameId) {
  return request({
    url: '/web/game/wiseEyesIdentifyBeads/'+ gameId,
    method: 'get',
  })
}

//万里挑一
export function  getTheOne(gameId) {
  return request({
    url: '/web/game/theOne/'+ gameId,
    method: 'get',
  })
}

//迷幻踪迹
export function  getPsychedelic(gameId) {
  return request({
    url: '/web/game/psychedelicTrail/'+ gameId,
    method: 'get',
  })
}

//层层递进
export function  getProgressive(gameId) {
  return request({
    url: '/web/game/progressive/'+ gameId,
    method: 'get',
  })
}

//无独有偶
export function  getGoodThings(gameId) {
  return request({
    url: '/web/game/goodThingsComeInPairs/'+ gameId,
    method: 'get',
  })
}

//对号入座
export function  getAccording(gameId) {
  return request({
    url: '/web/game/magicRestoration/'+ gameId,
    method: 'get',
  })
}

//图片连连看
export function  getKeepLooking(gameId) {
  return request({
    url: '/web/game/KeepLooking/'+ gameId,
    method: 'get',
  })
}

//声音连连判
export function  getvoiceKeepLooking(gameId) {
  return request({
    url: '/web/game/voiceKeepLooking/'+ gameId,
    method: 'get',
  })
}

//快速拨号
export function  getFastMemory(gameId) {
  return request({
    url: '/web/game/fastMemory/'+ gameId,
    method: 'get',
  })
}

//一清二楚
export function getCrystalClear(gameId) {
  return request({
    url: '/web/game/beCrystalClear/'+ gameId,
    method: 'get',
  })
}

//课程平均成绩  5篇文章
export function putAverage(data) {
  return request({
    url: '/web/course/courseaverage/add',
    method: 'post',
    data:data,
  })
}


//课程文章成绩  一篇文章已给
export function putHapterscore(data) {
  return request({
    url: '/web/course/coursechapterscore/add',
    method: 'post',
    data:data,
  })
}

//提交时间日志
export function logsbmit(data) {
  return request({
    url: '/web/us/add',
    method:'post',
    data:data,
  })
}

//提交用户行为日志
export function addBehaviorLog(data) {
  return request({
    url: '/web/behavior/log/add',
    method:'post',
    data:data,
  })
}

// 新增会员课程游戏
export function addCourseGame(data) {
  return request({
    url: '/web/course/membercoursegame/add',
    method:'post',
    data:data,
  })
}

// 查询体验课程下的游戏id
export function queryCourseGameId(memberId) { 
  return request({
    url: 'read/course/allocation/getCourseGameId',
    method: 'get',
  })
}

// 查询游戏等级
export function queryGameGradeByCourseId(data) {
  return request({
    url: '/web/course/queryGameGradeByCourseId',
    method:'get',
    params:data,
  })
}

// 新增会员课程进入日志
export function addEnterLog(data) {
  return request({
    url: '/web/exception/log/add',
    method:'post',
    data:data,
  })
}
